import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import bannerImg from '@/assets/logo.png';
import ModalPopup from '@/components/ModalPopup';
import SuccessPopup from '@/components/SuccessPopup';
import CustomPopup from '@/components/CustomPopup';
import TopImg from '@/assets/topImg.png';
import BtnImg from '@/assets/btn.png';
import BtnTip from '@/assets/btnTip.png';
import upImg from '@/assets/up.png';
import styles from './index.module.scss';
import { trackPageView, trackPageProgress, trackClickCTA, trackViewContent, trackPurchaseFB } from '@/utils/analytics';

export default () => {
  const [successVisible, setSuccessVisible] = useState(false);
  const [progressTracked, setProgressTracked] = useState({
    25: false,
    50: false,
    75: false,
    100: false
  });

  useEffect(() => {
    // 页面浏览埋点（原有）
    trackPageView();
    // FB Pixel 标准浏览埋点
    trackViewContent();

    const params = new URLSearchParams(window.location.search);
    if (params.get('success') === '1' || params.get('respMsg') == 'success') {
      setSuccessVisible(true);
      trackPurchaseFB(0.09, 'USD');
    }

    // 监听页面滚动，上报进度埋点（防抖处理）
    let scrollTimer = null;
    const handleScroll = () => {
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }

      scrollTimer = setTimeout(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / scrollHeight) * 100;

        if (scrollPercent >= 25 && !progressTracked['25']) {
          trackPageProgress(25);
          setProgressTracked((prev) => ({ ...prev, 25: true }));
        }
        if (scrollPercent >= 50 && !progressTracked['50']) {
          trackPageProgress(50);
          setProgressTracked((prev) => ({ ...prev, 50: true }));
        }
        if (scrollPercent >= 75 && !progressTracked['75']) {
          trackPageProgress(75);
          setProgressTracked((prev) => ({ ...prev, 75: true }));
        }
        if (scrollPercent >= 99 && !progressTracked['100']) {
          trackPageProgress(100);
          setProgressTracked((prev) => ({ ...prev, 100: true }));
        }
      }, 300); // 300ms 防抖
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimer) clearTimeout(scrollTimer);
    };
  }, [progressTracked]);
  const router = useRouter();

  const [showAll, setShowAll] = React.useState(false);
  const boxText = `Novel Subscription – User Notice\nDear reader, thank you for choosing to subscribe to our digital novel service!\nBefore completing your payment, please read the following terms carefully.\nBy clicking “Subscribe Now” and completing the purchase, you acknowledge and agree to all items below:\n---\n1. Product Description\nThis subscription provides access to digital novel chapters, delivered in electronic format only.\n- No physical books will be shipped.\n- After purchase, chapters may be delivered directly inside the app, via your account library, or through email depending on your subscription plan.\n---\n2. Account & Usage Rules\n- Your subscription is tied exclusively to your personal account and may not be shared, transferred, or resold.\n- Distribution, copying, or unauthorized sharing of any book content is strictly prohibited.\n- If any misuse or copyright infringement is detected, the platform reserves the right to suspend or terminate your access without a refund.\n---\n3. Content Updates & Service Adjustments\n- New chapters, bonus content, or revisions may be added regularly based on the publication schedule.\n- The platform may update, adjust, or optimize the reading experience based on user feedback.\n- Important updates will be communicated via email or in-app notifications.\n---\n4. Pricing & Subscription Policy\n- This product follows an auto-renewing subscription model.\n- After your first purchase, auto-renewal is enabled by default.\n- Unless you cancel at least 24 hours before the renewal date, the system will automatically charge the next billing cycle to your payment method.\n- Pricing is based on the amount displayed at the time of purchase.\n- Should future price adjustments occur, you will be notified via email or in-app notice prior to renewal.\n---\n5. Cancellation & Refunds\n- As this is an instantly accessible digital reading service, all purchases are non-refundable once completed.\n- You may cancel auto-renewal at any time before the next billing cycle.\n- After cancellation, you will continue to access the chapters included in your current paid period until it expires.\n---\n6. Support & Contact\nIf you encounter any issues with your subscription or reading experience, please contact us:\n📧 bookroomhub@outlook.com\nWorking Hours: Monday–Friday, 9:00–18:00 (GMT-3)`;
  const boxTextArr = boxText.split('\n');
  const [popupVisible, setPopupVisible] = useState(false);
  return (
    <div className={styles.box}>
      <div className={styles.contain}>
        <div className={styles.banner}>
          <img src={bannerImg} alt="" />
          <div className={styles.bannerText}>The Secret Mrs. Dixon</div>
        </div>
        <div className={styles.container}>
          <div className={styles.titles}>The Secret Mrs. Dixon</div>

          <video src="/video/tip.mp4" className={styles.titleImg} autoPlay loop muted playsInline />
          <div className={styles.titles}>Chapter 1</div>
          <div className={styles.text}>
            Thalia Hayes was a little absent-minded at the moment. All she could think of since this afternoon was the
            doctor's words. "Congratulations! You are pregnant." Suddenly, Mitchel Dixon pinched her arm hard. His low
            voice came the next second. "Come back to earth. What are you thinking about?" Before she could respond to
            that, Mitchel kissed Thalia hard after holding the back of her head lovingly. He then went into the
            bathroom. Thalia lay motionless in the massive bed. Damp strands of her hair stuck to her temples and
            cheeks. She stared at the ceiling with her eyes brimming with tears. Her naked body was aching slightly.
          </div>
          <div className={styles.titles}>Chapter 2</div>
          <div className={styles.text}>
            Thalia had mixed feelings as she stared at the pregnancy test result. In the end, she decided to tell
            Mitchel the truth. She also wanted to tell him that she hadn’t learned about him for the first time two
            years ago and that she had been crushing on him for many years before then. The shower in the bathroom
            finally went off. As soon as Mitchel came out, his phone rang. He went to the balcony with only a bath towel
            and answered the phone. Thalia checked the time and found that it was already midnight. She felt a little
            uneasy. Who would call Mitchel at this ungodly hour? Mitchel spent a few minutes on the balcony. Thereafter,
            he returned to the room and stripped away the bath towel. His figure was a sight to behold. The packs on his
            belly were bulky. His buttocks were hard and his legs were long and muscular. This man was a catch!
          </div>
          <div className={styles.titles}>Chapter 3</div>
          <div className={styles.text}>
            A little distressed, Thalia asked in a low voice, “I would like to visit my grandma tomorrow. Can you
            accompany me there?” Frail and ill, her grandmother always wanted to see her. As a result, Thalia wanted to
            take Mitchel there to assure her grandma they were happy. “Let’s talk about it tomorrow, okay?” Without
            agreeing or declining, Mitchel left in a hurry. Several thoughts were threading Thalia’s mind as she took a
            shower and got back to bed. She couldn’t sleep a wink. After tossing and turning for a long time, she got
            out of bed and made herself a warm glass of milk. A few notifications from some online blogs came into her
            phone. However, she wasn’t interested in them. She was about to swipe them away when one of them caught her
            attention. The familiar name made her click on it.
          </div>
          <div className={styles.box}>
            <div className={styles.boxTitle}>User Guidelines</div>
            <div className={styles.boxText}>
              {showAll
                ? boxTextArr.map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))
                : boxTextArr.slice(0, 2).map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      {!showAll && <span>...</span>}
                      <br />
                    </React.Fragment>
                  ))}
            </div>
            <div className={styles.boxBtn} onClick={() => setShowAll((v) => !v)} style={{ cursor: 'pointer' }}>
              <img
                src={upImg}
                alt=""
                style={{
                  transition: 'transform 0.3s',
                  transform: showAll ? 'rotate(180deg)' : 'none',
                  verticalAlign: 'middle'
                }}
              />{' '}
              {showAll ? 'Collapse' : 'View all'}
            </div>
          </div>
        </div>

        <CustomPopup visible={popupVisible} onClose={() => setPopupVisible(false)} />
        <SuccessPopup visible={successVisible} onClose={() => setSuccessVisible(false)} />
      </div>
      <div className={styles.btnBox}>
        <div
          className={styles.btn}
          onClick={() => {
            trackClickCTA();
            setPopupVisible(true);
          }}
        >
          <img src={BtnImg} className={styles.btnImg} alt="" />
          <img src={BtnTip} className={styles.btnTip} alt="" />
        </div>
        <div className={styles.btnText}>Original price $19.9</div>
      </div>
    </div>
  );
};
